import { useTranslation } from "react-i18next";
import { Chip, Stack, Typography, useTheme } from "@mui/material";
import {
  ACTION_TYPES,
  getProposedActionLabels,
  normalizeProposedAction,
} from "../../../../../helpers/correctiveActions";
import { caseTypeLabel } from "../../../../../helpers/caseClassification";

/**
 * Resumen de una accion propuesta en la conclusion. Lo comparten el modo
 * edicion y la vista de la conclusion para que ambas muestren lo mismo:
 * tipo, destinatario (si es sancion) y la lista de acciones elegidas.
 */
export const ProposedActionTitle = ({ measure }) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const action = normalizeProposedAction(measure);
  if (!action) return null;

  const isSanction = action.type === ACTION_TYPES.SANCTION;
  const labels = getProposedActionLabels(measure);

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap">
        <Chip
          size="small"
          label={
            isSanction
              ? t("Conclusion.action_type_sanction")
              : t("Conclusion.action_type_measure")
          }
          sx={{
            fontSize: 11,
            height: 20,
            color: theme.palette.white.main,
            backgroundColor: isSanction
              ? theme.palette.red.main
              : theme.palette.primary.main,
          }}
        />
        {isSanction && action.involved?.name && (
          <Typography
            fontSize={13}
            fontWeight={600}
            color={theme.palette.oxfordBlue.main}
          >
            {action.involved.name}
          </Typography>
        )}
        {/* Por cuál clasificación del caso va la propuesta */}
        {action.case_type && (
          <Chip
            size="small"
            variant="outlined"
            label={caseTypeLabel(action.case_type)}
            sx={{ fontSize: 11, height: 20 }}
          />
        )}
      </Stack>
      <Typography
        fontSize={14}
        fontWeight={600}
        color={theme.palette.blueGray600.main}
      >
        {labels.join(", ")}
      </Typography>
    </Stack>
  );
};

export const ProposedActionDetails = ({ measure }) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const action = normalizeProposedAction(measure);
  if (!action?.details) return null;

  return (
    <Typography
      fontSize={14}
      fontWeight={600}
      color={theme.palette.blueGray600.main}
    >
      {t("Conclusion.details")}:
      <Typography
        component="span"
        fontSize={12}
        fontWeight={400}
        color={theme.palette.oxfordBlue.main}
        fontStyle="italic"
      >
        {` ${action.details}`}
      </Typography>
    </Typography>
  );
};
